module.exports = __webpack_public_path__ + "static/img/rotate01.26264d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate01.png
// module id = HA+A
// module chunks = 1